import { FormControl, styled } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

export const StyledModalFpa = {
  Form: styled("form")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    margin: "auto",
    width: "fit-content",
    justifyContent: "center",
  })),
  FormControl: styled(FormControl)(({ theme }) => ({
    margin: theme.spacing(1),
    minWidth: 200,
  })),

  DatePicker: styled(DatePicker)(({ theme }) => ({
    margin: theme.spacing(1),
    minWidth: 200,
  })),
  dialogContent: {
    overflow: "hidden",
  },
};
